export const GROUPS = [
  {
    id: 'groupA',
    name: 'Группа A',
    teams: [
      {
        name: 'Италия',
        countryCode: 'IT',
        games: 3,
        goalsScored: 7,
        goalsAgainst: 0,
        points: 9
      },
      {
        name: 'Уэльс',
        countryCode: 'GB-WLS',
        games: 3,
        goalsScored: 3,
        goalsAgainst: 2,
        points: 4
      },
      {
        name: 'Швейцария',
        countryCode: 'CH',
        games: 3,
        goalsScored: 4,
        goalsAgainst: 5,
        points: 4
      },
      {
        name: 'Турция',
        countryCode: 'TR',
        games: 3,
        goalsScored: 1,
        goalsAgainst: 8,
        points: 0
      }
    ]
  },
  {
    id: 'groupB',
    name: 'Группа B',
    teams: [
      {
        name: 'Бельгия',
        countryCode: 'BE',
        games: 3,
        goalsScored: 7,
        goalsAgainst: 1,
        points: 9
      },
      {
        name: 'Дания',
        countryCode: 'DK',
        games: 3,
        goalsScored: 5,
        goalsAgainst: 4,
        points: 3
      },
      {
        name: 'Финляндия',
        countryCode: 'FI',
        games: 3,
        goalsScored: 1,
        goalsAgainst: 3,
        points: 3
      },
      {
        name: 'Россия',
        countryCode: 'RU',
        games: 3,
        goalsScored: 2,
        goalsAgainst: 7,
        points: 3
      }
    ]
  },
  {
    id: 'groupC',
    name: 'Группа C',
    teams: [
      {
        name: 'Нидерланды',
        countryCode: 'NL',
        games: 3,
        goalsScored: 8,
        goalsAgainst: 2,
        points: 9
      },
      {
        name: 'Австрия',
        countryCode: 'AT',
        games: 3,
        goalsScored: 4,
        goalsAgainst: 3,
        points: 6
      },
      {
        name: 'Украина',
        countryCode: 'UA',
        games: 3,
        goalsScored: 4,
        goalsAgainst: 5,
        points: 3
      },
      {
        name: 'С.Македония',
        countryCode: 'MK',
        games: 3,
        goalsScored: 2,
        goalsAgainst: 8,
        points: 0
      }
    ]
  },
  {
    id: 'groupD',
    name: 'Группа D',
    teams: [
      {
        name: 'Англия',
        countryCode: 'GB-ENG',
        games: 3,
        goalsScored: 2,
        goalsAgainst: 0,
        points: 7
      },
      {
        name: 'Хорватия',
        countryCode: 'HR',
        games: 3,
        goalsScored: 4,
        goalsAgainst: 3,
        points: 4
      },
      {
        name: 'Чехия',
        countryCode: 'CZ',
        games: 3,
        goalsScored: 3,
        goalsAgainst: 2,
        points: 4
      },
      {
        name: 'Шотландия',
        countryCode: 'GB-SCT',
        games: 3,
        goalsScored: 1,
        goalsAgainst: 5,
        points: 1
      }
    ]
  },
  {
    id: 'groupE',
    name: 'Группа E',
    teams: [
      {
        name: 'Швеция',
        countryCode: 'SE',
        games: 3,
        goalsScored: 4,
        goalsAgainst: 2,
        points: 7
      },
      {
        name: 'Испания',
        countryCode: 'ES',
        games: 3,
        goalsScored: 6,
        goalsAgainst: 1,
        points: 5
      },
      {
        name: 'Словакия',
        countryCode: 'SK',
        games: 3,
        goalsScored: 2,
        goalsAgainst: 7,
        points: 3
      },
      {
        name: 'Польша',
        countryCode: 'PL',
        games: 3,
        goalsScored: 4,
        goalsAgainst: 6,
        points: 1
      }
    ]
  },
  {
    id: 'groupF',
    name: 'Группа F',
    teams: [
      {
        name: 'Франция',
        countryCode: 'FR',
        games: 3,
        goalsScored: 4,
        goalsAgainst: 3,
        points: 5
      },
      {
        name: 'Португалия',
        countryCode: 'PT',
        games: 3,
        goalsScored: 7,
        goalsAgainst: 6,
        points: 4
      },
      {
        name: 'Германия',
        countryCode: 'DE',
        games: 3,
        goalsScored: 6,
        goalsAgainst: 5,
        points: 4
      },
      {
        name: 'Венгрия',
        countryCode: 'HU',
        games: 3,
        goalsScored: 3,
        goalsAgainst: 6,
        points: 2
      }
    ]
  }
];
